import type { TeamsApi } from "@/v2/api/metadata/teams";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { TranslationsTab } from "@/v2/framework/dialog/types";
import { readApiData } from "@/v2/api/response";
import { formatTranslationsForUpdate } from "@/services/helpers";
import { buildTeamTranslationFields } from "../../translation-fields";

export function createTranslationsTab(options: {
  ctx: BackofficeContext;
  teamsApi: TeamsApi;
}): TranslationsTab {
  const { ctx, teamsApi } = options;

  return {
    kind: "translations",
    id: "translations",
    label: "Translations",
    persistence: "isolated",
    parentSubmitWithUnsavedTranslations: "block",
    fields: buildTeamTranslationFields,
    api: {
      get: async ({ values }) => {
        const team = values as { id: string | number };
        const translations = readApiData(await teamsApi.getTranslations(team.id));
        const list = Array.isArray(translations) ? translations : [];
        const translationsPerLanguage = (list as Array<{ languageId: string | number }>).reduce(
          (acc, translation) => {
            acc.set(String(translation.languageId), translation);
            return acc;
          },
          new Map(),
        );
        return { languages: ctx.read.languages(), translationsPerLanguage };
      },
      save: async (model, saveCtx) => {
        const entityId = (saveCtx.values as { id: string | number }).id;
        await teamsApi.update(entityId, {
          translations: formatTranslationsForUpdate(
            model as Parameters<typeof formatTranslationsForUpdate>[0],
          ),
        });
      },
    },
  };
}
